function p(p,e,t,u){p._m(e);var _=t("730e4430");p._(e,"AppRoutes",_),p._(e,"default",_,"App");}